export default __webpack_public_path__ + "static/media/Belt of Righteous Smiting.339c239e.jpg";